import posthog from 'posthog-js'

const token = document.querySelector('meta[name="posthog-token"]')?.content
if (token) {
  posthog.init(token, {
    api_host: 'https://web.agentintel.co',
    defaults: '2026-05-30',
    loaded: client => client.register({
      prefers_reduced_motion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      scroll_timeline_supported: CSS.supports('animation-timeline: view()'),
      internal_or_test_user_hostname: /(^localhost$|^127\.0\.0\.1$|\.a\.agentintel\.co$)/.test(window.location.hostname),
    }),
  })
  window.posthog = posthog
}
